import React, { useEffect, useState } from 'react';
import { isEqual } from 'lodash';
import Inventory from './Inventory';

import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import queryString from 'query-string';
import { hasRole, RoleTypes } from '../../../core/components/Permission';
import { selectInventory } from '../reducer';
import {
  viewPermissionRefs,
  findPermissionRef,
} from '../../../core/components/UserGroupPermissions';
import Tabs from '../../../core/components/Tabs';
import { selectPermissions, selectUserGroup, selectRole } from '../../../store/authReducer';
import InventoryTypeTable from '../components/InventoryTypeTable';

export const component = () => {
  const intl = useIntl();
  const location = useLocation();
  const dispatch = useDispatch();
  const query = queryString.parse(location.search);
  const inventory = useSelector(selectInventory);
  const permissions = useSelector(selectPermissions);
  const userGroup = useSelector(selectUserGroup);
  const currentRole = useSelector(selectRole);
  const [tabType, setTabType] = useState('inventory');
  const tabComponents = [
    {
      component: <Inventory />,
      title: intl.formatMessage({ id: 'inventory' }),
      permissionKey: viewPermissionRefs.inventory,
      type: 'inventory',
    },
    {
      component: <InventoryTypeTable />,
      title: intl.formatMessage({ id: 'types' }),
      permissionKey: viewPermissionRefs.inventory,
      type: 'inventory-types',
    },
  ];
  const getTabsProps = () => ({
    tabs: tabComponents,
    onClick: setTabType,
    selectedType: tabType,
  });

  const setTabs = () => {
    if (
      hasRole(currentRole, RoleTypes.OperatorGroupAdmin) ||
      findPermissionRef(userGroup.permissions, viewPermissionRefs.expense)
    ) {
      return setTabType(tabComponents[0].type);
    }
  };

  useEffect(() => {
    setTabs();
  }, [permissions]);

  const visibleComponent = tabComponents.find((t) => t.type === tabType);
  return (
    <div className="container-fluid">
      <Tabs {...getTabsProps()} />
      <section className="page-main-content">
        <div className="row">{visibleComponent.component}</div>
      </section>
    </div>
  );
};

export const InventoryTabs = React.memo(component, isEqual);

export default InventoryTabs;
